/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {createEditorJSInstance as ɵb} from './lib/containers/editorjs/editorjs.module';
export {FOR_ROOT_OPTIONS_TOKEN as ɵa} from './lib/types/config';
export {EDITORJS_MODULE_IMPORT as ɵc,EditorJSClass as ɵe,EditorJSInstance as ɵd} from './lib/types/injector';